import { useUserStore } from "@/store/user";
import { useFeatureStore } from "@/store/feature";
import { LAYOUT_V2 } from "@/utils/variables";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ to, redirect, pinia }: MiddlewareInterface) => {
  if (to.name !== "landing") {
    return;
  }

  if (!to.params.id) {
    return;
  }

  if (useUserStore(pinia).isLoggedIn) {
    await redirect(useFeatureStore(pinia).getLandingUrl);
  }

  to.meta.landing_id = to.params.id;
  to.meta.layout = LAYOUT_V2;
};
